<div class="container p-4">
    <div class="row mt-5">
        <div class="col-md-6 offset-md-3">
            <div class="card">
                <div class="card-header bg-primary">
                    <div class="row justify-content-between align-items-center">
                        <div class="col">
                            <p class="h3 m-0 text-white d-inline-block">
                                Available Portals
                                <i class="fa fa-question-circle-o ml-2"
                                    tooltip="You have access to multiple instances of CMS. Select an instance to continue."></i>
                            </p>
                        </div>
                        <div class="col col-auto">
                            <button *userRoleToggle="['SuperAdmin']"
                                class="btn btn-outline-light btn-sm u-marginBottom--medium"
                                (click)="addNewBusinessFunction(this);">Create portal</button>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <ul class="list-group">
                        <li *ngFor="let businessFunction of businessFunctions"
                            class="list-group-item list-group-action border-left-0 border-right-0 border-bottom-0 d-block">
                            <div class="row justify-content-between align-items-center">
                                <div class="col">
                                    {{businessFunction?.displayName}}
                                </div>
                                <div class="col col-auto">
                                    <button class="btn btn-outline-info btn-sm" *ngIf="!businessFunction.disabled"
                                        (click)="setBusinessFunction(businessFunction)">Manage portal</button>
                                    <span class="text-danger" *ngIf="businessFunction.disabled">Decommissioned</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>